import OntologyRichLabel from "../components/ontologies/OntologyRichLabel"

import StringDecorator from "./StringDecorator"

export default class OntologiesInfoDecorator {

  static id = (ontology) => ontology?.ontology_id
  static label = (ontology) => ontology?.label
  static name = (ontology) => ontology?.name
  static link = (ontology) => ontology?.link

  static rolesInfo = ({ ontology, ontologies }) => {
    return Object.entries(ontology.roles).map(role => {
      return (this.dependenciesForRole({ role: role, ontologies: ontologies }))
    })
  }

  static dependencyInfo = ({ dependency }) => {
    return Object.entries(dependency).map(([dependencyName, dependencyIds]) => {
      return (
        <div>
          <b>
            {StringDecorator.toLabelSpelling(dependencyName) + ': '}
          </b>
          {dependencyIds.map((dependencyId, idx) =>
            <>
              <OntologyRichLabel ontologyId={dependencyId} />
              {idx < dependencyIds.length - 1 && ', '}
            </>
          )}
        </div>)
    })
  }

  static dependenciesForRole = ({ role, ontologies }) => {
    let [roleName, dependencies] = role

    return dependencies.map((dependency) => {
      return (<>
        <div className='row border-bottom'>
          <span>
            {'= '}
            <b>
              {StringDecorator.toLabelSpelling(roleName)}
            </b>
          </span>
          <div>
            {this.dependencyInfo({ dependency: dependency, ontologies: ontologies })}
          </div>
        </div>
      </>
      )
    })
  }

  static richLabel = (ont) => { return '[' + ont?.ontology_id + '] ' + (ont?.label || ont?.name || 'No label') }

  static richLabelOption = (ont) => {
    return {
      value: ont.ontology_id,
      label: this.richLabel(ont)
    }
  }

}
